import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import {
  Col,
  Container,
  Row,
  CardBody,
  Card,
  TabPane,
  TabContent,
} from 'reactstrap';
import { useHistory, useParams } from 'react-router-dom';
import Api from '../../util/api';
import Loading from '../../shared/components/custom/Loading';
import t, { partial } from '../../util/translation/translation';
import NavTab from '../../shared/components/custom/NavTab';
import SpotlightSegmentForm from './components/SpotlightSegmentForm';
import SegmentUserListPage from './components/SegmentUserListPage';

const SpotlightSegmentFormPage = () => {
  const history = useHistory();
  const [entity, setEntity] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('1');
  const { entityID } = useParams();
  const p = partial('HighlightBannerPage');
  const s = partial('shared');
  const getData = async () => {
    setLoading(true);
    try {
      const segmentData = await Api.spotlight.getSegmentById(entityID);
      setEntity(segmentData);
      setLoading(false);
    } catch (err) {
      toast.error(err);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (entityID) {
      getData();
    }
  }, [entityID]);
  const onSubmit = async (values) => {
    const payload = {
      name: values.name,
      description: values.description,
    };
    setLoading(true);
    try {
      if (entityID) {
        await Api.spotlight.updateSegment(entityID, payload);
        toast.success(p('segmentUpdated'));
      } else {
        await Api.spotlight.createSegment(payload);
        toast.success(p('segmentCreated'));
      }
      setLoading(false);
      history.replace('/segments');
    } catch (err) {
      if (err?.data?.message === 'segment.AlreadyExists') {
        toast.error(t('ErrorMessage.nameAlereadyExists'));
      }
      toast.error(err);
      setLoading(false);
    }
  };
  return (
    <Container>
      <Loading loading={loading} />
      <Row>
        <Col>
          <h3 className="page-title">
            {entityID ? s('update') : s('create')} {p('segment')}
          </h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card>
            <CardBody style={{ padding: 0, borderRadius: 6 }}>
              <NavTab
                tabs={[
                  { tab: s('details') },
                  { tab: s('users'), disabled: !entityID },
                ]}
                style={{ marginBottom: 0 }}
                setTab={setActiveTab}
                activeTab={activeTab}
                size="sm"
              />
              <div className="tabs tabs--justify tabs--bordered-top overflow-unset px-3 pb-3">
                <div className="tabs__wrap">
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                      <SpotlightSegmentForm
                        entity={entity}
                        onSubmit={onSubmit}
                      />
                    </TabPane>
                    <TabPane tabId="2">
                      <SegmentUserListPage
                        segmentId={entityID}
                        setLoading={setLoading}
                      />
                    </TabPane>
                  </TabContent>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SpotlightSegmentFormPage;
